import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const LifePathAndSubconsciousDescription = ({ visible, onClose, data }) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  if (!data) return null; // Check if data is available

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('life_path_and_subconscious_description')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>{t('life_path_number')} : {data.lifePathNumber}</h1>
        <h1>{t('subconscious_number')} : {data.subconsciousNumber}</h1>
        <p><strong>{t('life_path_and_subconscious_description')} : </strong>{currentLanguage == 'en' ? data.meaningEnglish : data.meaningThai}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LifePathAndSubconsciousDescription;